import { render, staticRenderFns } from "./showStudentSubjectDiary.vue?vue&type=template&id=5233a785&scoped=true"
import script from "./showStudentSubjectDiary.vue?vue&type=script&lang=js"
export * from "./showStudentSubjectDiary.vue?vue&type=script&lang=js"
import style0 from "./showStudentSubjectDiary.vue?vue&type=style&index=0&id=5233a785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233a785",
  null
  
)

export default component.exports